import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Container,
  Divider,
  Form,
  Grid,
  Header,
  Icon,
  Image,
  Message,
  Modal,
  Progress,
  Segment,
  Transition,
} from 'semantic-ui-react';
import * as Scroll from 'react-scroll';
import update from 'immutability-helper';
import XHRAsset from './xhr/asset.js';
import ColorSelection from './tool/ColorSelection.js';
import ThemeSelection from './tool/ThemeSelection.js';
import SocialFields from './tool/SocialFields.js';
import Options from './tool/Options.js';
import PanelTexts from './tool/PanelTexts.js';
import Utils from './Utils.js';

class Asset extends Component {
  constructor(props) {
    super(props);

    this.asset_type = this.props.match.params.asset;

    this.state = {
      username: '',
      theme: 'basic',
      capacities: [],
      step: 0,
      creating: false,
      errors: {
        username: false,
        facebook: false,
        instagram: false,
        twitter: false,
        youtube: false,
        message: null,
      },

      // after a given amount of try, display a message
      // to send us some feedbacks.
      triesCount: 0,

      // options
      last_follow: true,
      last_subscribe: true,
      last_donation: true,
      last_subscribe_text: 'Last Subscribe',
      last_donation_text: 'Last Donation',
      last_follow_text: 'Last Follow',
      camera_position: 'bottom_right',
      banner_middle_text: 'IS CURRENTLY',
      banner_big_text: 'Offline',

      // preview modal
      modal: { show: false, uid: null, thumb: null, },

      // panel texts
      panel_texts: [],

      // social
      facebook: '',
      instagram: '',
      twitter: '',
      youtube: '',

      fg: { r: 240, g: 240, b: 240, a: 1, },
      bg: { r: 40, g: 40, b: 40, a: 1, },
      text_color: 'auto',
    }
  }

  render() {
    return (
      <Container>
        <Form>
          { /* Step 1: theme */ }

          <ThemeSelection
            step={this.state.step}
            assetType={this.asset_type}
            onChangeTheme={this.onChangeTheme}
          />
          {this.state.step < 1 &&
            <div>
              <Divider hidden />
              <Form.Button loading={!this.state.capacities || this.state.capacities.length === 0} onClick={this.next} fluid>Next</Form.Button>
            </div>
          }

          { /* Step 2: username */ }

          <Transition visible={Utils.hasCapacity(this.state.capacities, 'username') && this.state.step >= 1} animation='fade' duration={500}>
          <Grid columns={1} stackable>
            <Grid.Column>
              <Segment>
                <Header as='h2' textAlign='left'>
                  <Icon name='user outline' />
                  <Header.Content>Username</Header.Content>
                  <Header.Subheader>First, please fill your streamer username.</Header.Subheader>
                </Header>
              </Segment>
            </Grid.Column>
            <Grid.Column>
              <Form.Field>
                <Form.Input size='huge' focus={true} value={this.state.username} error={this.state.errors.username} onChange={this.onUsername} placeholder="Your username" />
              </Form.Field>
              {this.state.step < 2 &&
                <Form.Button onClick={this.next} fluid>Next</Form.Button>
              }
            </Grid.Column>
          </Grid>
          </Transition>

          { /* Step 3: social accounts */ }

          <Transition visible={this.state.step >= 2} animation='fade' duration={500}>
            <Grid.Column>
              <SocialFields
                capacities={this.state.capacities}
                onFacebook={this.onFacebook}
                onInstagram={this.onInstagram}
                onTwitter={this.onTwitter}
                onYouTube={this.onYouTube}
              />
              <Divider hidden />
              {this.state.step < 3 &&
                <Form.Button onClick={this.next} fluid>Next</Form.Button>
              }
            </Grid.Column>
          </Transition>

          { /* Panels texts */ }

          <Transition visible={Utils.hasCapacity(this.state.capacities, 'panel_texts') && this.state.step > 0} animation='fade' duration={500}>
            <Grid.Column>
              <PanelTexts
                capacities={this.state.capacities}
                onPanelTextsChange={this.onPanelTextsChange}
              />
              <Divider hidden />
              {this.state.step < 2 &&
                <Form.Button onClick={this.next} fluid>Next</Form.Button>
              }
            </Grid.Column>
          </Transition>

          { /* Step 4: options */ }

          <Transition visible={this.state.step >= 3} animation='fade' duration={500}>
            <Grid.Column>
              <Options
                capacities={this.state.capacities}
                onCameraPosition={this.onCameraPosition}
                onLastDonation={this.onLastDonation}
                onLastSubscribe={this.onLastSubscribe}
                onLastFollow={this.onLastFollow}
                onLastDonationText={this.onLastDonationText}
                onLastSubscribeText={this.onLastSubscribeText}
                onLastFollowText={this.onLastFollowText}
                onBannerMiddleText={this.onBannerMiddleText}
                onBannerBigText={this.onBannerBigText}
              />
              <Divider hidden />
              {this.state.step < 4 &&
                <Form.Button onClick={this.next} fluid>Next</Form.Button>
              }
            </Grid.Column>
          </Transition>

          { /* Step 5: theme and color */ }

          <Transition visible={this.state.step >= 4 || (Utils.hasNoneCapacities(this.state.capacities, 'camera_pos', 'last_donation', 'last_subscribe', 'last_follow', 'banner_middle_text', 'banner_big_text') && this.state.step > 3)} animation='fade' duration={500}>
            <ColorSelection onTextColor={this.onTextColor} onBg={this.onBg} onFg={this.onFg} capacities={this.state.capacities} />
          </Transition>

        {this.state.step < 4 &&
          <Progress size='tiny' percent={(this.state.step+1)*((1/5)*100)} indicating />
        }
        {this.state.step === 4 && <div>
          <Divider hidden />
          {this.state.errors.message &&
            <Message
                negative
                content={<div><Icon name="info circle" /> {this.state.errors.message}</div>}
              />
          }
          {this.state.triesCount > 4 && <p style={{align: 'center', float: 'left'}}>You do not like what you see? We can do better? We want to hear from you! Don't hesitate to <a href='mailto:support@strmaker.com'>send us some feedbacks on support@strmaker.com!</a></p>}
          <Form.Button primary disabled={this.state.creating} loading={this.state.creating} onClick={this.create} fluid>Make!</Form.Button>
        </div>}
        </Form>


        <Modal dimmer='blurring' closeOnEscape={true} size='fullscreen' onClose={this.change} open={this.state.modal.show} basic>
          <Header icon='thumbs outline up' content='Preview' />
          <Modal.Content>
            <h4>Preview of the {this.asset_type} generated with these settings</h4>
            <Image centered bordered src={this.preview()} style={{maxWidth: '100%'}} alt={"Preview of the generated "+this.asset_type} />
          </Modal.Content>
          <Modal.Actions>
            <Button basic onClick={this.change} color='red' inverted>
              <Icon name='settings' /> Change settings
            </Button>
            <Link to={'/preview/'+this.asset_type+'/' +this.state.modal.uid + '/' + this.state.modal.thumb}>
              <Button color='green'>
                <Icon name='thumbs outline up' /> Continue
              </Button>
            </Link>
          </Modal.Actions>
        </Modal>
      </Container>
    );
  }

  onUsername = (event, data) => {
    this.setState({
      username: data.value,
    });
    if (data.value.length === 0) {
      let err = this.state.errors;
      err.username = true;
      this.setState({
        errors: err,
      });
    } else if (this.state.errors.username) {
      let err = this.state.errors;
      err.username = false;
      this.setState({
        errors: err,
      });
    }
  }

  // Called by SocialFields
  // ----------------------

  onFacebook = (v) => { this.setState({ facebook: v, }); }
  onInstagram = (v) => { this.setState({ instagram: v, }); }
  onTwitter = (v) => { this.setState({ twitter: v, }); }
  onYouTube = (v) => { this.setState({ youtube: v, }); }

  // called by Options
  // ----------------------

  onCameraPosition = (pos) => { this.setState({ camera_position: pos, }); }
  onLastFollow = (v) => { this.setState({ last_follow: v }); }
  onLastSubscribe = (v) => { this.setState({ last_subscribe: v }); }
  onLastDonation = (v) => { this.setState({ last_donation: v }); }
  onLastDonationText = (v) => { this.setState({ last_donation_text: v }); }
  onLastSubscribeText = (v) => { this.setState({ last_subscribe_text: v }); }
  onLastFollowText = (v) => { this.setState({ last_follow_text: v }); }
  onBannerMiddleText = (v) => { this.setState({ banner_middle_text: v }); }
  onBannerBigText = (v) => { this.setState({ banner_big_text: v }); }

  // Called by PanelTexts
  // ----------------------

  onPanelTextsChange = (texts) => { this.setState({panel_texts: texts}); }

  // Called by ThemeSelection.
  // ----------------------

  onChangeTheme = (theme, capacities, scroll) => {
    if (scroll) {
      if (this.state.step === 0) {
        this.setState({step: 1});
      }
      setTimeout(() => {
        Scroll.animateScroll.scrollToBottom();
      }, 100);
    }
    this.setState({
      theme: theme,
      capacities: capacities,
    });
  }

  // Called by ColorSelection.
  // ----------------------

  stringColor = (rgba) => {
    return 'rgba('+rgba.r+','+rgba.g+','+rgba.b+','+rgba.a+')';
  }

  onFg = (color) => {
    this.setState({ fg: color.rgb, });
  }

  onBg = (color) => {
    this.setState({ bg: color.rgb, });
  }

  onTextColor = (color) => {
    this.setState({ text_color: color });
  }

  // Asset tool next step
  // ----------------------

  next = () => {
    // username step
    if (Utils.hasCapacity(this.state.capacities, 'username')) {
      if (this.state.step >= 1 && this.state.username.length <= 0) {
        let err = this.state.errors;
        err.username = true;
        this.setState({
          errors: err,
        });
        return;
      }
    }

    let step = this.state.step;

    if (step === 1 && Utils.hasNoneCapacities(this.state.capacities, ['twitter','instagram','facebook','youtube'])) {
      step += 1; // skip this test
    }

    if (step === 2 && Utils.hasNoneCapacities(this.state.capacities, ['last_follow', 'last_subscribe', 'last_donation', 'camera_pos', 'banner_middle_text', 'banner_big_text'])) {
      step += 1; // skip this test
    }

    // next step
    setTimeout(() => {
      Scroll.animateScroll.scrollToBottom();
    }, 100);
    this.setState({ step: step+1, });
  }

  change = () => {
    let modal = this.state.modal;
    modal.show = false;
    this.setState({
      modal: modal,
    });
  }

  preview = () => {
    return process.env.REACT_APP_API_DOMAIN + '/api/' + this.asset_type + '/' + this.state.modal.thumb + '.png';
  }

  validate = () => {
    var msg = '';
    if (this.state.errors.facebook) {
      msg = 'Please fill the facebook field or uncheck it.';
    } else if (this.state.errors.instagram) {
      msg = 'Please fill the instagram field or uncheck it.';
    } else if (this.state.errors.twitter) {
      msg = 'Please fill the twitter field or uncheck it.';
    } else if (this.state.errors.youtube) {
      msg = 'Please fill the youtube field or uncheck it.';
    } else if (this.state.errors.username) {
      msg = 'Please fill your username / streamer name.';
    }
    return msg
  }

  create = () => {
    // validate the form
    let msg = this.validate();
    if (msg.length) {
      let e = this.state.errors;
      e.message = msg
      this.setState({
        errors: e,
      });

    }

    this.setState({
      triesCount: this.state.triesCount+1,
    });

    // remove displayed errors
    let e = this.state.errors;
    e.message = null;
    this.setState({
      errors: e,
      creating: true,
    });

    // xhr
    let ov = update(this.state, {$unset: ['creating', 'modal', 'errors', 'step', 'confirm_reset', 'capacities']});
    XHRAsset.create(this.asset_type, ov).then((response) => {
      let modal = this.state.modal;
      modal.show = true;
      modal.thumb = response.thumb;
      modal.uid = response.uid;
      this.setState({
        modal: modal,
        creating: false,
      });
    }).catch((response) => {
      response.json().then((data) => {
        if (data.msg === 'bad parameter') {
          let e = this.state.errors;
          e.message = 'Please correctly fill the ' + data.param + ' field.';
          this.setState({
            creating: false,
            errors: e,
          });
        } else {
          let e = this.state.errors;
          e.message = 'An error occurred, please contact support@strmaker.com';
          this.setState({
            creating: false,
            errors: e,
          });
        }
      })
      console.log('error:', response);
    });
  }
}

export default Asset;



// WEBPACK FOOTER //
// ./src/Asset.js